{
    "save": "Gem",
    "cancel": "Annuller",
    "back": "Tilbage",
    "next": "Næste",
    "submit": "Send",
    "loading": "Indlæser...",
    "language": "Sprog",
    "languageDescription": "Vælg sprog til menuer, knapper og påmindelser.",
    "profile": {
        "title": "Profil",
        "description": "Administrer din profil og dine indstillinger",
        "contactDetails": "Kontaktoplysninger",
        "languageGroup": "Sprog",
        "otherActions": "Andre handlinger",
        "changePassword": "Skift adgangskode",
        "logout": "Log ud",
        "incompleteTitle": "Profil ufuldstændig",
        "incompleteMessage": "For at bruge Patient Watch skal du først udfylde din profil med alle felter, der er markeret som manglende nedenfor."
    },
    "nav": {
        "diaries": "Dagbøger"
    }
}
